import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  AppModule,
  RoleCreateRequest,
  RoleDetail,
  RoleUpdateRequest,
} from '../models/role.model';

/**
 * API de gestión de roles avanzados.
 * IMPORTANTE: estos endpoints derivan el businessId del JWT (lo pone el authInterceptor);
 * NO se envía businessId como parámetro (a diferencia de otros módulos del CRM).
 */
@Injectable({ providedIn: 'root' })
export class RoleApiService {
  private url = `${environment.apiUrl}api/roles`;

  constructor(private http: HttpClient) {}

  /** Catálogo de módulos (filas de la matriz). Ordenar por orderPosition en el componente. */
  getModules(): Observable<AppModule[]> {
    return this.http.get<AppModule[]>(`${this.url}/modules`);
  }

  /** Roles gestionables (sistema + custom) con su matriz de permisos. */
  getManagedRoles(): Observable<RoleDetail[]> {
    return this.http.get<RoleDetail[]>(`${this.url}/managed`);
  }

  /** Detalle de un rol. */
  getRole(id: number): Observable<RoleDetail> {
    return this.http.get<RoleDetail>(`${this.url}/${id}`);
  }

  /** Crea un rol custom (201 Created). */
  createRole(req: RoleCreateRequest): Observable<RoleDetail> {
    return this.http.post<RoleDetail>(this.url, req);
  }

  /** Edita un rol custom. Si se envía `permissions`, reemplaza la matriz completa. */
  updateRole(id: number, req: RoleUpdateRequest): Observable<RoleDetail> {
    return this.http.put<RoleDetail>(`${this.url}/${id}`, req);
  }

  /** Borra un rol custom (204 No Content). */
  deleteRole(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
